import './externs'
import makeIo from './make-io'
import positionAbsolute from '@lemuria/absolute-proxy'

/**
 * When image-placeholder is scrolled into view.
 * @param {!HTMLElement} object
 */
const callback = (object) => {
  if (!object) return
  const potrace = object.getAttribute('data-potrace')
  if (!potrace) return
  const potraceNoAnimate = object.getAttribute('data-potrace-no-animate') !== null
  const potraceNoInteract = (object.getAttribute('data-potrace-no-interact') !== null) || potraceNoAnimate

  object.removeAttribute('data-potrace')
  const oid = object.id.replace(/^s/, 'o')

  const obj = /** @type {!HTMLElement} */ (document.createElement('object'))
  obj.type = 'image/svg+xml'
  obj.style.visibility = 'hidden'
  obj.id = oid
  obj.data = potrace

  positionAbsolute(obj, object)
  window.addEventListener('element-resize', () => {
    positionAbsolute(obj, object['_picture'] || object)
  })

  obj.onload = potraceNoAnimate ? () => {
    obj.style.visibility = ''
  } : () => {
    const { contentDocument: doc } = obj
    const svg = doc.querySelector('svg')
    const use = svg.querySelector('use[data-mask]')
    use.setAttribute('mask', use.getAttribute('data-mask'))
    use.setAttribute('fill', 'none')

    animatePaths(svg)
    use.setAttribute('stroke', use.getAttribute('data-stroke'))

    obj.style.visibility = ''

    use.removeAttribute('data-stroke')
    use.removeAttribute('data-mask')
  }

  let clearTransition = true
  if (!potraceNoInteract) obj.onmouseover = () => {
    // debugger
    if (!obj['_finishedAppear']) return

    obj.style.opacity = ''
    animatePaths(obj.contentDocument.querySelector('svg'), {
      clearTransition,
    })
    clearTransition = false
  }
  if (!potraceNoInteract) obj.onmouseleave = () => {
    if (!obj['_finishedAppear']) return

    animatePaths(obj.contentDocument.querySelector('svg'), {
      reverse: true,
    })
    // obj.style.opacity = 0
  }

  document.body.appendChild(obj)
}

/**
 * @param {Element} svg
 * @param {Object} [opts]
 * @param {boolean} [opts.reverse]
 * @param {number} [opts.seconds]
 * @param {boolean} [opts.clearTransition]
 */
const animatePaths = (svg, opts = {}) => {
  const {
    reverse = false, seconds = 7, clearTransition = false,
  } = opts

  /** @type {Array<SVGPathElement>} */
  const paths = [...svg.querySelectorAll('path')]

  paths.forEach((path) => {
    const length = path.getTotalLength()
    // Clear any previous transition
    if (clearTransition)
      path.style.transition = path.style.webkitTransition = 'none'

    const l = `${length}`
    // Set up the starting positions
    path.style['strokeDasharray'] = `${length} ${length}`
    path.style['strokeDashoffset'] = reverse ? '0' : l

    // Trigger a layout so styles are calculated & the browser
    // picks up the starting position before animating
    path.getBoundingClientRect()

    // Define our transition
    path.style.transition = path.style.webkitTransition =
      `stroke-dashoffset ${seconds}s ease-in-out`

    // Go!
    path.style['strokeDashoffset'] = reverse ? l : '0'
  })
}

export default function SPLENDID_CONTOURS(className = 'ImageHolder', options = {
  rootMargin: '100px',
}) {
  /** @type {Array<Element>} */
  const objects = [...document.querySelectorAll(`img.${className}`)]
  const io = makeIo(callback, options)
  objects.forEach((object) => {
    io.observe(object)
  })
}